import App from "../app";
import {
  EventConfig,
  Event,
  EventAPIConfig,
  EventAPIReturnOptions,
} from "../interfaces";
const HOST =
  process.env.NODE_ENV === "production"
    ? "http://events.bsi-sc.com"
    : "http://127.0.0.1:9000";
const api = App.API({
  options: {
    headers: {
      "Content-Type": "application/json",
    },
  },
  // baseURL: `${HOST}`,
  path: "events",
});

export default {
  getEvents: async (): Promise<any> => await api.post("fetch", {}),
  getEvent: async (config: EventAPIConfig): Promise<any> =>
    await api.post("fetch", config),
  patchEventDetails: async (config: EventAPIConfig): Promise<any> =>
    await api.post("update/details", config),
  patchEventStructure: async (config: EventAPIConfig): Promise<any> =>
    await api.post("update/slots", config),
  patchEventPlayers: async (config: EventAPIConfig): Promise<any> =>
    await api.post("update/players", config),
  deleteEventPlayers: async (config: EventAPIConfig): Promise<any> =>
    await api.post("remove/players", config),
  deleteEventSlot: async (config: EventAPIConfig): Promise<any> =>
    await api.post("remove/slot", config),
  findPlayer: async (name: string): Promise<any> =>
    await api.post("find/player", { name }),
  genEvent: async (eventConfig: EventAPIConfig): Promise<any> =>
    await api.post("new", <EventAPIConfig>eventConfig),
  getSquadrons: async (): Promise<any> => await api.post("squadrons", {}),
  EventAPIReturnOptions,
};
